import { useTranslation } from "react-i18next";
import { SectionCard } from "../../components/SectionCard/SectionCard.js";
import { SectionCardHeader } from "../../components/SectionCard/SectionCardHeader.js";
import { SectionCardHStack } from "../../components/SectionCard/SectionCardHStack.js";
import { SectionCardGrid } from "../../components/SectionCard/SectionCardGrid.js";
import { SectionCardVStack } from "../../components/SectionCard/SectionCardVStack.js";
import { NavigationActionButton } from "../../components/NavigationActionButton/NavigationActionButton.js";

export function TimberSection() {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col gap-24">
            <SectionCard
                id="timber-purchases"
                img="cards/timber-cropped.png"
                className="bg-pine"
                gradientClassName="pine-gradient"
            >
                <SectionCardHeader
                    title={t("home-timber-purchases-card-title")}
                    text={t("home-timber-purchases-card-text")}
                />
                <SectionCardGrid className="grid-cols-3">
                    <SectionCardHStack
                        title={t("home-timber-purchases-card-section-1-title")}
                        text={t("home-timber-purchases-card-section-1-text")}
                    />
                    <SectionCardVStack
                        img="cards/tablet-cropped.png"
                        title={t("home-timber-purchases-card-section-2-title")}
                        text={t("home-timber-purchases-card-section-2-text")}
                    />
                    <SectionCardVStack
                        img="cards/harvest-cropped.png"
                        title={t("home-timber-purchases-card-section-3-title")}
                        text={t("home-timber-purchases-card-section-3-text")}
                    />
                    <SectionCardVStack
                        img="cards/sun-cropped.png"
                        title={t("home-timber-purchases-card-section-4-title")}
                        text={t("home-timber-purchases-card-section-4-text")}
                    />
                </SectionCardGrid>
            </SectionCard>
            <SectionCard
                id="final-felling-drone-praxis"
                className="bg-pine !gap-12"
                img="cards/final-felling-drone-praxis-cropped.png"
                gradientClassName="pine-gradient"
            >
                <SectionCardVStack
                    title={t("home-final-felling-drone-praxis-card-title")}
                    text={t("home-final-felling-drone-praxis-card-text")}
                    className="mr-0 sm:mr-32 lg:mr-[36rem]"
                >
                    <NavigationActionButton
                        className="my-0 !text-black !bg-white hover:!bg-[rgba(255,255,255,0.9)] w-full sm:w-min"
                        label={t("learn-more")}
                        href="/final-felling-drone-praxis"
                    />
                </SectionCardVStack>
            </SectionCard>
        </div>
    );
}
